import { useEffect, useState } from "react";

import { ScreenSize } from "../types";
import { isClient } from "@/utils/browser";

const TABLET_MAX = 1232;
const SMALL_DESKTOP_MIN = 940;
const SMALL_DESKTOP_MAX = 1200;

function getScreenSizeFromWindow(breakPoint: number): ScreenSize {
  if (!isClient()) {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: false,
      isSmallDesktop: false,
    };
  }
  const w = window.innerWidth;
  return {
    isMobile: w < breakPoint,
    isTablet: w >= breakPoint && w < TABLET_MAX,
    isDesktop: w > TABLET_MAX,
    isSmallDesktop: w > SMALL_DESKTOP_MIN && w < SMALL_DESKTOP_MAX,
  };
}

function screenSizeEquals(a: ScreenSize, b: ScreenSize): boolean {
  return (
    a.isMobile === b.isMobile &&
    a.isTablet === b.isTablet &&
    a.isDesktop === b.isDesktop &&
    a.isSmallDesktop === b.isSmallDesktop
  );
}

export const useWindowSize = (mobileBreakpoint?: number): ScreenSize | undefined => {
  const defaultBreakPoint = 718;
  const breakPoint = mobileBreakpoint ?? defaultBreakPoint;

  const [screenSize, setScreenSize] = useState<ScreenSize>(() =>
    getScreenSizeFromWindow(breakPoint)
  );

  useEffect(() => {
    if (!isClient()) return;

    const handleWindowResize = () => {
      const next = getScreenSizeFromWindow(breakPoint);
      setScreenSize((prev) => (screenSizeEquals(prev, next) ? prev : next));
    };

    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [breakPoint]);

  return screenSize;
};
